module.exports = __webpack_public_path__ + "static/media/14_crear_menu_plantilla_complejo_galeria_blanca.08aed06f.jpg";